
import { Badge, Button, Checkbox, Divider, InputBase, InputLabel, Paper, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import ReactQuill from "react-quill";
import Loader from '../../component/Loader'
import PopUpAlert from '../../component/PopUpAlert'
import { MdPersonSearch } from "react-icons/md";
import 'react-quill/dist/quill.snow.css';
import { IoClose } from "react-icons/io5";
import { UserAPI } from "../../api/UserAPI";
import { NotificationAPI } from "../../api/NotificationAPI";
import { AuthAPI } from "../../api/AuthAPI";
import filterLogo from '../../assets/images/filter.png'
import notFoundImg from '../../assets/images/not-found.png'
import funnelImg from '../../assets/images/funnel.png'
import { useSelector } from "react-redux";
import { Privileges } from "../../util/PrivilegeConstants"
import { useDispatch } from "react-redux";
import { rootAction } from "../../redux/reducer/rootReducer";
import { PrivilegeAPI } from "../../api/PrivilegesAPI";


const EmailNotify = () => {
    const [message, setMessage] = useState('');
    const [subject, setSubject] = useState('no subject');
    const [isLoading, setIsLoading] = useState(false);
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const [allRecipients, setAllRecipients] = useState([])
    const [checkAll, setCheckAll] = useState(false);
    const [checkedItems, setCheckedItems] = useState([]);
    const [openFilter, setOpenFilter] = useState(false);
    const [filterRole, setFilterRole] = useState([]);
    const [filteredRecipient, setFilteredRecipient] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const [privileges, setPrivileges] = useState({});

    const { userInfo, clubId } = useSelector((store) => store.user);
    const dispatch = useDispatch();

    const isAllSelected = () => {
        if (checkedItems.length < allRecipients.length) {
            setCheckAll(false);
        }
        if (checkedItems.length == allRecipients.length && allRecipients.length != 0) {
            setCheckAll(true);
        }
    }
    const isObjectPresentById = (data, idToCheck) => {
        return data.some((item) => item.id === idToCheck);
    };
    const handleCheckboxChange = (name) => {
        if (isObjectPresentById(checkedItems, name.id)) {
            setCheckedItems(checkedItems.filter((item) => item.id !== name.id));
        } else {
            setCheckedItems([...checkedItems, name]);
        }
    };
    const handleSetFilter = (role) => {
        if (filterRole.includes(role)) {
            setFilterRole(filterRole.filter((item) => item !== role));
        }
        else {
            setFilterRole([...filterRole, role]);
        }
    }
    const handleChackAll = () => {
        setCheckAll(!checkAll);
        allRecipients.map((item) => {
            if (!isObjectPresentById(checkedItems, item.id)) {
                setCheckedItems((prev) => [...prev, item]);
            }
        })
        if (checkedItems.length >= allRecipients.length) {
            setCheckedItems([]);
        }
    }

    const fetchRecipients = async () => {
        try {
            let filterRoles = null
            if (filterRole.length == 1) {
                filterRoles = `groupNames=${filterRole[0]}`
            }
            if (filterRole.length == 2) {
                filterRoles = `groupNames=${filterRole[0]}&groupNames=${filterRole[1]}`
            }
            if (filterRole.length == 3) {
                filterRoles = `groupNames=${filterRole[0]}&groupNames=${filterRole[1]}&groupNames=${filterRole[2]}`
            }

            if (filterRole && filterRole.length > 0) {
                setIsLoading(true);
                const response = await UserAPI.getUsersForNotifications(filterRoles, clubId)
                setAllRecipients(response.Data);
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            console.error(error);
        }
    }
    const handleSearch = (event) => {
        setSearchInput(event.target.value);
        setFilteredRecipient(allRecipients.filter((item) => item.name.toLowerCase().includes(event.target.value.toLowerCase())));
    }
    const sendEmail = async () => {
        const clubLogo = `${import.meta.env.VITE_APP_BASE_URL}/club/club-logo-img/${userInfo.clubs[0].clubLogo}`;
        if (checkedItems.length == 0) {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Please select at least 1 user' }));
            return;
        }
        const emailInfo = {
            templateName: 'EMAIL_BLAST_TMP',
            templateData: `{\"clubLogo\":\"${clubLogo}\",\"emailBlastBody\":${JSON.stringify(message)},\"subject\":\"${subject}\"}`,
            destinationEmail: checkedItems?.map(f => f.email),
            sourceEmail: "no-reply@sportmingle.com"
        }

        try {
            setIsLoading(true);
            const result = await NotificationAPI.postSendEmail(emailInfo);
            setMessage('');
            setSubject('no subject');
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: result.Message }));
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: error.message }));
        }
    }
    const verifyCaptcha = async (data) => {

        try {
            const response = await AuthAPI.postVerifyCaptcha(data);
            setCaptchaVerified(response.Data);
        } catch (error) {

        }
    }

    const findAllPrivileges = async () => {
        try {
            setIsLoading(true)
            const reqObj = {
                userId: userInfo.userId,
                featureName: Object.keys(Privileges)[8]
            }
            const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
            setPrivileges(response.Data);
            
        } catch (error) {
            console.log(error);
        }finally{
            setIsLoading(false);
        }
    };

    useEffect(() => {
        isAllSelected();
    }, [checkedItems])

    useEffect(() => {
      if(userInfo?.userId){
          findAllPrivileges();
      }
    }, [userInfo?.userId])
    
    return (
        <div className='email-bast-container'>
            {isLoading && <Loader />}
            <div className="email-bast-filter">
                <div className="email-bast-filter-heading">
                    <h1>select recipients</h1>
                    <Badge badgeContent={filterRole.length == 0 ? '0' : filterRole.length} color="success">
                        <button onClick={() => setOpenFilter(true)}>filter <span><img src={filterLogo} alt="" /></span></button>
                    </Badge>
                </div>
                <div className="email-bast-filter-searchbar">
                    <Paper
                        tabIndex={0}
                        component="form"
                        className="search-box"
                        sx={{
                            p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%', boxShadow: 0,
                            borderWidth: "2px",
                            borderStyle: "solid",
                        }}
                    >
                        <InputLabel id='in'><MdPersonSearch className="email-bast-filter-searchbar-icon" /></InputLabel>
                        <InputBase
                            id='in'
                            sx={{ ml: 1, flex: 1 }}
                            value={searchInput || ''}
                            onChange={handleSearch}
                            placeholder="Search recipients"
                            inputProps={{ 'aria-label': 'search google maps' }}
                        />
                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                    </Paper>

                </div>
                <div className="email-bast-filter-table-heading">
                    <Checkbox checked={checkAll} onClick={handleChackAll} />
                    <p>name <span id="selected-recipient">{checkedItems.length}</span></p>
                </div>
                {allRecipients.length != 0 &&
                    <div className="email-bast-filter-table-row">
                        {searchInput.trim() === '' && allRecipients.map((item, index) =>
                            <div key={index} className="email-bast-filter-table-row-details">
                                <Checkbox
                                    id={item.id}
                                    checked={isObjectPresentById(checkedItems, item.id)}
                                    onClick={() => handleCheckboxChange(item)}
                                />
                                <p>{item.name}</p>
                            </div>)}
                        {searchInput.trim() !== '' && filteredRecipient.map((item, index) =>
                            <div key={index} className="email-bast-filter-table-row-details">
                                <Checkbox
                                    id={item.id}
                                    checked={isObjectPresentById(checkedItems, item.id)}
                                    onClick={() => handleCheckboxChange(item)}
                                />
                                <p>{item.name}</p>
                            </div>)}
                    </div>}
                {(allRecipients.length == 0 && filterRole.length != 0) &&
                    <div className="recipient-data-not-found">
                        <img src={notFoundImg} alt="" />
                        <p>No result found</p>
                    </div>}
                {(allRecipients.length == 0 && filterRole.length == 0) &&
                    <div className="filter-data-not-found">
                        <img src={funnelImg} alt="" />
                        <p>Please select a role from the above filter to view results.</p>
                    </div>}
                <div className={openFilter ? "email-bast-filter-options active" : "email-bast-filter-options"}>
                    <div className="email-bast-filter-input">
                        <Checkbox
                            id="player"
                            onChange={() => handleSetFilter('player')}
                        />
                        <p>Player</p>
                    </div>
                    <div className="email-bast-filter-input">
                        <Checkbox
                            id="staff"
                            onChange={() => handleSetFilter('staff')}
                        />
                        <p>Staff</p>
                    </div>
                    <div className="email-bast-filter-input">
                        <Checkbox
                            id="coach"
                            onChange={() => handleSetFilter('coach')}
                        />
                        <p>Coach</p>
                    </div>

                    <div className="apply-filter-button">
                        <Button
                            onClick={() => {
                                fetchRecipients();
                                setSearchInput('');
                                setFilteredRecipient([]);
                                setOpenFilter(false);
                            }}
                            variant="contained">Filter</Button>
                    </div>
                    <IoClose className="filter-close-icon" onClick={() => setOpenFilter(false)} />
                </div>
            </div>
            <div className="email-bast-body">
                <div className="email-bast-to">
                    <div className="email-bast-to-text">To</div>
                    <div className="email-bast-to-text-body">
                        {checkedItems.map((item, index) =>
                            <>
                                <span key={item.id}>{item.name}</span>
                                {index < checkedItems.length - 1 && <span>,</span>}
                            </>
                        )}
                    </div>
                </div>
                <div className="email-bast-subject">
                    <TextField className="email-bast-subject-input" fullWidth id="subject" value={subject} onChange={(e) => setSubject(e.target.value)} size="small" name="subject" label="Subject" variant="outlined" />
                </div>
                <div className="email-bast-editor">
                    <ReactQuill theme="snow" className="editor-input" value={message} onChange={setMessage} />
                </div>
                
                {privileges?.MANAGE_EMAIL_NOTIFICATION?.includes(Privileges.SEND) &&
                    <div className="email-bast-send-btn">
                        <Button variant="contained" onClick={sendEmail} >Send</Button>
                    </div>}
            </div>
        </div>
    )
}

export default EmailNotify